<!--临时客商新增  -->
<template>
	<div class="info-box">
		<el-dialog title="客商信息" v-if="dialogVisible" :visible.sync="dialogVisible" :close-on-click-modal="false" width="1000px" top="3vh"
			:close-on-press-escape="false" :modal-append-to-body="false" :before-close="cancle">
			<div class="info-title">基础信息:</div>

			<!--  -->
			<div class="form-box mt15">
				<el-form label-position="right" :inline="true" size="small" :model="ruleForm" :rules="rules"
					ref="ruleForm" label-width="100px">
					<el-form-item label="客商编号" prop="agentCode" v-if="rowData.agentId">
						<el-input v-model.trim="ruleForm.agentCode" class="w190" maxlength="16"
							:disabled="rowData.agentId?true:false"></el-input>
					</el-form-item>

					<el-form-item label="客商名称" prop="agentName">
						<el-input v-model.trim="ruleForm.agentName" class="w190" maxlength="20"></el-input>
					</el-form-item>
					<el-form-item label="组织结构" prop="groupId" v-if="!rowData.agentId">
						<el-select v-model="ruleForm.groupId" class="w190" size="small" placeholder="选择"
							@change="handleGroup">
							<el-option v-for="item in groupDate" :key="item.groupId" :label="item.groupName"
								:value="item.groupId">
							</el-option>
						</el-select>
					</el-form-item>
					<div class="w420 fl">
						<div class="flex flex-between w330">
							<el-form-item label="结算方式" prop="settlementType">
								<el-select v-model="ruleForm.settlementType" class="w90" size="small" placeholder="选择"
									:disabled="rowData.agentId?true:false">
									<el-option label="现金" value="0">
									</el-option>
									<el-option label="账期" value="1">
									</el-option>
									<!-- <el-option label="其它" value="2">
									</el-option> -->
								</el-select>
							</el-form-item>
							<!-- <el-checkbox class="ml10 mt5" v-model="ruleForm.advancesFlag">是否预付款</el-checkbox> -->
						</div>
					</div>

					<el-form-item label="客商简称">
						<el-input v-model.trim="ruleForm.agentShortName" class="w190" maxlength="15"></el-input>
					</el-form-item>
					<el-form-item label="渠道(NC)" prop="ncChannelName" v-if="rowData.agentId">
						<el-input v-model.trim="ruleForm.ncChannelName" class="w190" maxlength="16"
							:disabled="rowData.agentId?true:false"></el-input>
					</el-form-item>
					<el-form-item label="特渠">
						<el-select v-model="ruleForm.specialChannel" class="w190" size="small" placeholder="选择">
							<el-option v-for="item in codeList" :key="item.codesetId" :label="item.itemName"
								:value="item.codesetId">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="销售范围" prop="skuIds">
						<el-select v-model="ruleForm.skuIds" multiple class="w190" size="small" placeholder="选择">
							<el-option v-for="item in skuList" :key="item.skuId" :label="item.skuName"
								:value="item.skuId">
							</el-option>
						</el-select>
					</el-form-item>

					<!-- <el-form-item label="渠道细分">
                        <el-input v-model.trim="ruleForm.channelMince" class="w190" maxlength="16"></el-input>
                    </el-form-item> -->
					<el-form-item label="联系人" prop="contacts">
						<el-input v-model.trim="ruleForm.contacts" class="w190" maxlength="8"></el-input>
					</el-form-item>

					<el-form-item label="所属区域">
						<el-input v-model.trim="ruleForm.agentArea" class="w190" maxlength="16"></el-input>
					</el-form-item>
					<el-form-item label="联系手机" prop="contactsPhone">
						<el-input v-model.trim="ruleForm.contactsPhone" class="w190" maxlength="15"></el-input>
					</el-form-item>

					<el-form-item label="销售据点分类">
						<el-select v-model="ruleForm.agentTag1" class="w190" size="small" placeholder="选择">
							<el-option label="分公司" value="分公司"></el-option>
							<el-option label="外仓" value="外仓"></el-option>
							<el-option label="营业所" value="营业所"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="详细地址">
						<el-input v-model.trim="ruleForm.address" class="w190" maxlength="20"></el-input>
					</el-form-item>
					<!-- <el-form-item label="客商标签2">
						<el-autocomplete
							class="w190"
							:maxlength="10"
							v-model="ruleForm.agentTag2"
							:fetch-suggestions="querySearch"
							placeholder="请输入内容">
						</el-autocomplete>
					</el-form-item> -->
					<el-form-item label="客商标签3">
						<el-autocomplete
							class="w190"
							:maxlength="10"
							v-model="ruleForm.agentTag3"
							:fetch-suggestions="querySearch"
							placeholder="请输入内容">
						</el-autocomplete>
					</el-form-item>

					<div v-if="rowData.agentId">
						<div class="info-title">NC信息:</div>
						<!--  -->
						<div class="mt5">
							<div class="flex nc-box">
								<div class="flex-1">
									<span class="info-name"> NC编码: </span>
									<span class="ml15"> {{rowData.ncCode||'无'}}</span>
								</div>
								<div class="flex-1">
									<span class="info-name"> NC内码： </span>
									<span class="ml15"> {{rowData.ncId||'无'}}</span>
								</div>
							</div>
							<!--  -->
							<!--  -->
							<div class="flex nc-box">
								<div class="flex-1">
									<span class="info-name"> NC专管部门: </span>
									<span class="ml15"> {{rowData.ncDepart||'无'}}</span>
								</div>
								<div class="flex-1">
									<span class="info-name"> NC销售组织： </span>
									<span class="ml15"> {{rowData.ncSalesOrg||'无'}}</span>
								</div>
							</div>
							<!--  -->
							<!--  -->
							<div class="flex nc-box">
								<div class="flex-1">
									<span class="info-name"> NC库存组织: </span>
									<span class="ml15"> {{rowData.ncInventoryOrg||'无'}}</span>
								</div>
								<div class="flex-1">
									<span class="info-name"> NC币种： </span>
									<span class="ml15"> {{rowData.ncCurrency||'无'}}</span>
								</div>
							</div>
							<!--  -->
							<!--  -->
							<div class="flex nc-box">
								<div class="flex-1">
									<span class="info-name"> NC仓库档案: </span>
									<span class="ml15"> {{rowData.ncWarehouse||'无'}}</span>
								</div>
								<div class="flex-1">
									<span class="info-name"> NC开票商管理档案编码: </span>
									<span class="ml15"> {{rowData.ncDrawerCode||'无'}}</span>
								</div>
							</div>
							<!--  -->
							<!--  -->
							<div class="flex nc-box">
								<div class="flex-1">
									<span class="info-name"> NC收货单位: </span>
									<span class="ml15"> {{rowData.ncConsigneeCode||'无'}}</span>
								</div>
								<div class="flex-1">
									<span class="info-name"> NC开票单位： </span>
									<span class="ml15"> {{rowData.ncDrawer||'无'}}</span>
								</div>
							</div>
							<!--  -->
							<!--  -->
							<div class="flex nc-box">
								<div class="flex-1">
									<span class="info-name"> NC开票单位名称: </span>
									<span class="ml15"> {{rowData.ncDrawerName||'无'}}</span>
								</div>
								<div class="flex-1">
									<span class="info-name"> NC客商管理档案主键： </span>
									<span class="ml15"> {{rowData.ncPkcumandoc||'无'}}</span>
								</div>
							</div>
							<!--  -->
							<!--  -->
							<div class="flex nc-box">
								<div class="flex-1">
									<span class="info-name"> NC组织1: </span>
									<span class="ml15"> {{rowData.ncGroupName||'无'}}</span>
								</div>
								<div class="flex-1">
									<span class="info-name"> NC开票商PK值： </span>
									<span class="ml15"> {{rowData.ncDrawerPk||'无'}}</span>
								</div>
							</div>
							<!--  -->
							<!--  -->
							<div class="flex nc-box">
								<div class="flex-1">
									<span class="info-name"> NC集团内外: </span>
									<span class="ml15"> {{rowData.ncJttype||'无'}}</span>
								</div>
								<div class="flex-1">
									<span class="info-name"> NC联系人： </span>
									<span class="ml15"> {{rowData.ncLinkman||'无'}}</span>
								</div>
							</div>
							<!--  -->
							<!--  -->
							<div class="flex nc-box">
								<div class="flex-1">
									<span class="info-name"> NC联系电话1: </span>
									<span class="ml15"> {{rowData.ncPhone||'无'}}</span>
								</div>
								<div class="flex-1">
									<span class="info-name"> NC纳税登记号： </span>
									<span class="ml15"> {{rowData.ncTaxpayerId||'无'}}</span>
								</div>
							</div>
							<!--  -->
							<!--  -->
							<div class="flex nc-box">
								<div class="flex-1">
									<span class="info-name"> NC所属地区: </span>
									<span class="ml15"> {{rowData.ncArea||'无'}}</span>
								</div>
								<div class="flex-1">
									<span class="info-name"> NC系列： </span>
									<span class="ml15"> {{rowData.ncSerial||'无'}}</span>
								</div>
							</div>
							<!--  -->
						</div>

					</div>

				</el-form>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button size="small" @click="cancle()">取 消</el-button>
				<el-button size="small" type="primary" @click="submitForm('ruleForm')">确 定</el-button>
			</span>
		</el-dialog>

	</div>
</template>

<script>
	import {
		debounce
	} from '@/utils/debounce'
	export default {
		components: {},
		data() {
			return {
				dialogVisible: false,
				groupDate: [],
				ruleForm: {
					groupId: "",
					agentName: "",
					agentShortName: "",
					settlementType: "",
					advancesFlag: "",
					skuIds: [],
					specialChannel: "",
					contacts: "",
					address: "",
					agentTag1: "",
					agentTag2: "",
					agentTag3: "",
					agentCode: "",
					ncChannelName: "",
					channelMince: "",
					ncAreaCode: "",
					contactsPhone: "",
					agentArea: "",
				},
				rules: {
					agentName: [{
						required: true,
						message: '请输入客商名称',
						trigger: 'blur'
					}, ],
					settlementType: [{
						required: true,
						message: '请选择结算方式',
						trigger: 'change'
					}, ],
					skuIds: [{
						type: 'array',
						required: true,
						message: '请选择销售范围',
						trigger: 'change'
					}],
					contacts: [{
						pattern: /^[\u4e00-\u9fa5a-zA-Z]{1,8}?$/,
						message: '请输入8位以内汉字、英文',
					}],
					contactsPhone: [{
						pattern: /^[0-9-]{1,15}?$/,
						message: '请输入15位以内数字中划线',
					}, ],
					groupId: [{
						required: true,
						message: '请选择组织结构',
						trigger: 'change'
					}, ],

				},
				skuList: [],
				rowData: {},
				codeList: [],
				agentTagList: []
			}
		},
		created() {

		},
		methods: {
			init(data) {
				this.dialogVisible = true;
				this.$nextTick(() => {
					this.agentTagList = [];
					this.rowData = {}
					this.getSkuList()
					this.getAgentSelectList()
					this.getCodeList()
					this.ruleForm = {
						groupId: "",
						agentName: "",
						agentShortName: "",
						settlementType:"0",
						advancesFlag: "",
						skuIds: [],
						specialChannel: "",
						contacts: "",
						address: "",
						agentTag1: "",
						agentTag2: "",
						agentTag3: "",
						agentCode: "",
						ncChannelName: "",
						channelMince: "",
						ncAreaCode: "",
						contactsPhone: ""
					}
				})
			},
			//  客商标签获取
			getAgentTags() {
				let that = this;
				that.$request.post(
						"getAgentTags",
						false, {
							groupId: that.ruleForm.groupId
						}
					)
					.then((res) => {
						if (res) {
							that.agentTagList = [];
							res.data.forEach(item => {
								that.agentTagList.push({
									"value": item
								})
							})
						}
					})
			},
			querySearch(queryString, cb) {
				// 调用 callback 返回建议列表的数据
				cb(this.agentTagList);
			},
			// 组织结构处理
			handleGroup() {
				this.ruleForm.agentTag1 = '';
				this.ruleForm.agentTag2 = '';
				this.ruleForm.agentTag3 = '';
				this.getAgentTags();
			},
			//  sku获取
			getSkuList() {
				let that = this;
				that.$request.post(
						"skuList",
						false, {
							settlementType: '0'
						}
					)
					.then((res) => {
						if (res) {
							that.skuList = res.data
						}
					})
			},
			//  特渠获取
			getCodeList() {
				let that = this;
				that.$request.post(
						"agentCodeList",
						false, {
							"codesetCode": "SP_CHANNEL"
						}
					)
					.then((res) => {
						if (res) {
							that.codeList = res.data
						}
					})
			},
			// 组织结构
			getAgentSelectList() {
				let that = this;
				that.$request.post(
						"agentSelectList",
						false, {}
					)
					.then((res) => {
						if (res) {
							that.groupDate = res.data
						}
					})
			},

			// 保存
			submitForm: debounce(function () {
				this.$refs['ruleForm'].validate((valid) => {
					if (valid) {
						this.$confirm('是否确认保存？', {
							confirmButtonText: '确定',
							cancelButtonText: '取消',
						}).then(() => {
							if (!this.rowData.agentId) {
								this.addRow()
							} else {
								this.updateRow()
							}
						}).catch(() => {});
					} else {
						console.log('error submit!!');
						return false;
					}
				});
			}, 1000, true),

			// 新增
			addRow() {
				let that = this;
				that.$request.post(
						"agentAdd",
						true, {
							groupId: that.ruleForm.groupId,
							agentName: that.ruleForm.agentName,
							agentShortName: that.ruleForm.agentShortName,
							settlementType: that.ruleForm.settlementType,
							advancesFlag: that.ruleForm.advancesFlag ? "Y" : "N",
							skuIds: that.ruleForm.skuIds.join(","),
							specialChannel: that.ruleForm.specialChannel,
							contacts: that.ruleForm.contacts,
							address: that.ruleForm.address,
							agentTag1: that.ruleForm.agentTag1,
							agentTag2: that.ruleForm.agentTag2,
							agentTag3: that.ruleForm.agentTag3,
							channelMince: that.ruleForm.channelMince,
							ncAreaCode: that.ruleForm.ncAreaCode,
							contactsPhone: that.ruleForm.contactsPhone,
							agentArea: that.ruleForm.agentArea
						}
					)
					.then((res) => {
						if (res) {
							that.dialogVisible = false
							that.$message.success("保存成功！");
							that.$refs['ruleForm'].resetFields();
							that.$emit("getList")
						}

					})
			},
			// 修改
			updateRow() {
				let that = this;
				that.$request.post(
						"agentUpdate",
						false, {
							agentId: that.rowData.agentId,
							groupId: that.ruleForm.groupId,
							agentName: that.ruleForm.agentName,
							agentShortName: that.ruleForm.agentShortName,
							settlementType: that.ruleForm.settlementType,
							advancesFlag: that.ruleForm.advancesFlag ? "Y" : "N",
							skuIds: that.ruleForm.skuIds.join(","),
							specialChannel: that.ruleForm.specialChannel,
							contacts: that.ruleForm.contacts,
							address: that.ruleForm.address,
							agentTag1: that.ruleForm.agentTag1,
							agentTag2: that.ruleForm.agentTag2,
							agentTag3: that.ruleForm.agentTag3,
							channelMince: that.ruleForm.channelMince,
							ncAreaCode: that.ruleForm.ncAreaCode,
							contactsPhone: that.ruleForm.contactsPhone,
						}
					)
					.then((res) => {
						if (res) {
							that.dialogVisible = false
							that.$message.success("保存成功！");
							that.$refs['ruleForm'].resetFields();
							that.$emit("getList")

						}
					})
			},
			// 取消
			cancle() {

				this.$nextTick(() => {
					this.$refs['ruleForm'].resetFields();
				})
				this.dialogVisible = false

			},
		},
		beforeDestroy() {

		}
	}

</script>
<style lang='scss' scoped>
	.mb0 {
		margin-bottom: 0 !important;
	}

	.w90 {
		width: 110px;
	}

	.nc-box {
		padding: 10px;
		border-bottom: 1px solid #DCDFE6;
		color: #606266;
		font-size: 13px;
	}

	.mb10 {
		margin-bottom: 10px !important;
	}

	.w190 {
		width: 280px !important;
	}

	.info-box {
		/deep/ .el-dialog__body {
			// height: 350px;
			padding: 20px 20px 10px;
			overflow-y: auto;
		}
	}

	.info-title {
		background: #E5E5E5;
		color: #333;
		padding: 10px;
		box-sizing: border-box;
		font-size: 16px;
		font-weight: bold;
	}

	.el-form-item {
		width: 420px;
	}

	.w330 {
		width: 330px;
	}

	.w420 {
		width: 420px !important;
		margin-right: 10px;
	}

	.info-name {
		display: inline-block;
		width: 140px;
		text-align: right;
		color: #999;
	}

</style>
